import { isRecentlyChanged } from "@/components/event-action/helper/EventBoardRecentlyChangedHelper";
import { DateTime } from "luxon";
import { EABFilterImplementationType, EABFilterType, type FilterOption } from "@/graphql";
import type { EventFilter, ActionFilter } from "../FilterTypes";
import RecentlyChangedFilterUI from "../ui/RecentlyChangedFilterUI.vue";
import RecentlyChangedFilterBadge from "../ui/badges/RecentlyChangedFilterBadge.vue";

export default class RecentlyChangedFilter implements EventFilter, ActionFilter {
  constructor(
    public readonly definitionOfRecentInHours: number,
    public readonly isNegated?: boolean,
    public readonly includeActionChanges = false,
  ) {}

  static readonly Badge = RecentlyChangedFilterBadge;

  static readonly UI = RecentlyChangedFilterUI;

  getEventFilter(): FilterOption | undefined {
    const value = {
      value: DateTime.now().minus({ hours: this.definitionOfRecentInHours }).toISO(),
      negated: this.isNegated ?? false,
    };
    const eventFilter: FilterOption = {
      filter: {
        type: EABFilterImplementationType.EVENT_UPDATED_AT_SINCE,
        value,
      },
    };

    if (!this.includeActionChanges) {
      return eventFilter;
    }

    return {
      operation: {
        type: this.isNegated ? EABFilterType.AND : EABFilterType.OR,
        filters: [
          eventFilter,
          {
            filter: {
              type: EABFilterImplementationType.ACTION_UPDATED_AT_SINCE,
              value,
            },
          },
        ],
      },
    };
  }

  getActionFilter(): FilterOption | undefined {
    return {
      filter: {
        type: EABFilterImplementationType.ACTION_UPDATED_AT_SINCE,
        value: {
          value: DateTime.now().minus({ hours: this.definitionOfRecentInHours }).toISO(),
          negated: this.isNegated ?? false,
        },
      },
    };
  }

  isRecentlyChanged(time: DateTime) {
    return isRecentlyChanged(time, this.definitionOfRecentInHours);
  }
}
